import {seoMetadata as SeoMetadata} from "@next/utils"
import State from "../../../../models/State"
import {NO_INDEX_NO_FOLLOW_META_ROBOTS} from "../../../../config/constants"

interface SeoMetadata {
    title: string
    keywords: string
    description: string
    robots: string
    canonical?: string
}

export const checkTaxonomyUrlAndRedirectOldUrls = (state: State, seoMetadata: SeoMetadata) => {
    const newSeoMetadata: SeoMetadata = {...seoMetadata}
    if (state.search.enableTaxonomy && state.search.redirectOldUrlsToNoResults && !state.request.isMerchandisedUrl) {
        newSeoMetadata.robots = NO_INDEX_NO_FOLLOW_META_ROBOTS
    }
    return newSeoMetadata
}
